import * as React from 'react'

import { DrawerBase } from './DrawerBase'

type TDrawerProps = Omit<PropsOf<typeof DrawerBase>, 'isFullHeight'>

type TProps = RequiredChildren & TDrawerProps

/**
 * drawer opening from the bottom side of the page,
 * covers the whole page (kind of an alternative to Modal/new screen)
 * useful mainly on small devices
 */
export const FullScreenDrawer: React.FC<TProps> = ({ children, ...drawerProps }) => {
  return (
    <DrawerBase
      {...drawerProps}
      overflow={`visible`}
      isFullHeight
      // reasonable defaults (?)
      headerProps={{
        shadow: `medium`,
        padding: `medium`,
        overContent: false,
        bgColor: drawerProps.headerProps?.overContent ? undefined : `bgColors.card`,
        ...drawerProps.headerProps,
      }}
      containerProps={{
        padding: `medium`,
        ...drawerProps.containerProps,
      }}
      footerProps={{
        shadow: `medium`,
        padding: `medium`,
        ...drawerProps.footerProps,
      }}
    >
      {children}
    </DrawerBase>
  )
}
